export default __webpack_public_path__ + "static/media/images-1-1.b3aa8325.jpg";